import React, { Component, useState } from "react";
import Accordion from "../UI/Accordion";
import RadioInput from "../UI/RadioInput";
import DatePicker from "react-datepicker";
import moment from "moment/moment";

import "react-datepicker/dist/react-datepicker.css";

export class Location extends Component {
    continue = (e) => {
        e.preventDefault();

        if (this.props.values.step2FormValid) {
            this.props.nextStep();
        }

        try {
            if (typeof (ga) === "function") {
                var fields = {
                    hitType: "event",
                    event_category: "InstaQuote",
                    eventAction: "completed Moving Date",
                    value: "2",
                };

                window.gtag('event', fields.eventAction, fields);
            }
        } catch (err) {
            console.log("Error Logging Google Analytics Event for Step 2 - Online booking");
        }
    };
    previous = (e) => {
        e.preventDefault();
        this.props.prevStep();
    };

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { values, handleChange, handleDateChange } = this.props;
        return (
            <div className="ob-bg">
                <div className="ob-wrapper">
                    <h2 className="ob-h2">{document.getElementById("Step2Title").value}</h2>
                    <Accordion title="What day are you moving?" open={true} date>
                        <DatePicker
                            selected={values.movingDate}
                            onChange={(date) => handleDateChange(date)}
                            name="movingDate"
                            minDate={new Date(+new Date() + 86400000)}
                            dateFormat="MM/dd/yyyy"
                            inline
                            formatWeekDay={(nameOfDay) => nameOfDay.substr(0, 1)}
                        />
                    </Accordion>
                    <Accordion title="How big is your house?" open={true}>
                        <fieldset className="ob-input__radio-fieldset">
                            <legend className="visually-hidden">
                                Select your Dwelling type?
                            </legend>
                            <RadioInput
                                label="Small"
                                subLabel="1 bedroom or less"
                                id="houseSizeSmall"
                                name="houseSize"
                                value="small"
                                checked={values.houseSize === "small"}
                                onChange={handleChange("houseSize")}
                                svg="#icon-house-s"
                                viewBox="-5 -5 31 28"
                            />
                            <RadioInput
                                label="Medium"
                                subLabel="2-4 bedrooms"
                                id="houseSizeMedium"
                                name="houseSize"
                                value="medium"
                                checked={values.houseSize === "medium"}
                                onChange={handleChange("houseSize")}
                                svg="#icon-house-m"
                                viewBox="0 0 40 40"
                            />
                            <RadioInput
                                label="Large"
                                subLabel="5+ bedrooms"
                                id="houseSizeLarge"
                                name="houseSize"
                                value="large"
                                checked={values.houseSize === "large"}
                                onChange={handleChange("houseSize")}
                                svg="#icon-house-l"
                                viewBox="0 0 60 45"
                            />
                        </fieldset>
                    </Accordion>
                    <Accordion title="Are you moving a vehicle?" open={true}>
                        <fieldset className="ob-input__radio-fieldset">
                            <legend className="visually-hidden">
                                How big is your house?
                            </legend>
                            <RadioInput
                                label="Yes"
                                subLabel="I am moving a vehicle"
                                id="movingVehicleYes"
                                name="movingVehicle"
                                value="yes"
                                checked={values.movingVehicle === "yes"}
                                onChange={handleChange("movingVehicle")}
                                svg="#icon-garage-yes"
                                viewBox="0 0 45 40"
                            />
                            <RadioInput
                                label="No"
                                subLabel="I am not moving a vehicle"
                                id="movingVehicleNo"
                                name="movingVehicle"
                                value="no"
                                checked={values.movingVehicle === "no"}
                                onChange={handleChange("movingVehicle")}
                                svg="#icon-garage-no"
                                viewBox="0 0 45 40"
                            />
                        </fieldset>
                    </Accordion>
                    <div className="ob-btn__container">
                        <button className="ob-btn ob-btn--half" onClick={this.previous}>
                            {document.getElementById("Step2BackButtonText").value}
                        </button>
                        <button className="ob-btn ob-btn--half" onClick={this.continue}>
                            {document.getElementById("Step2NextButtonText").value}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default Location;
